import React, { useState, useEffect, useRef } from 'react';
import view1 from '../../../assets/images/show.png';
import info from '../../../assets/images/infor.png';
import ck1 from '../../../assets/images/ck1.png';
import ck2 from '../../../assets/images/ck2.png';
import close from '../../../assets/images/close.png';
import alert1 from '../../../assets/images/alert1.png';
import ck3 from '../../../assets/images/ck3.png';
import cb3 from '../../../assets/images/cb3.png';

import Header from '../../../Components/Header/Header'
import LeftMenu from '../../../Components/LeftMenu/LeftMenu'
import TopMenu from '../../../Components/TopMenu/TopMenu'
import View from "../../../assets/images/view.png";

import { Modal, Button, Dropdown, Row, Col, Form, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFilter, faDownload } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETDESTINATION, MONITORLOADINGSTATION, MONITORUNLOADINGSTATION, TRUCKERSEARCH, TRUCKORDERSDETAILS, BOOKINGTRUCKDETAILS } from '../../../Utils/conts.js';
import Loader from '../../../Components/common/Loader.js';

const Dashboard = () => {

    const isMounted = useRef(false);
    const [searchData, setSearchData] = useState({ search_area: '', o_id: '' });
    const [searchItems, setSearchItems] = useState({});
    const [truckOrder, setTruckOrder] = useState({});
    const [openScheduleTruck, setOpenScheduleTruck] = useState({});
    const [urgentModerateSafeCount, setUrgentModerateSafe] = useState([]);
    const [truckRequestCount, setTruckRequestCount] = useState([]);
    const [truckOfferReceived, setTruckOfferReceived] = useState([]);
    const [truckRgnDrpdwnLabel, setTruckRgnDrpdwnLabel] = useState({});
    const [selectedRegion, setSelectedRegion] = useState("All Region");



    const openTruckOrder = async () => {
        try {
            const res = await withRFSToken.get('open-truck-orders')
                .then(function (res) {
                    const truckoderinnerData = res.data.response_data.data;
                    setTruckOrder(truckoderinnerData);

                    const truckRequestCountData = res.data.response_data.indicators.requested;
                    setTruckRequestCount(truckRequestCountData);

                    const truckOrderOfferRecivedData = res.data.response_data.indicators.offer_received;
                    setTruckOfferReceived(truckOrderOfferRecivedData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOpenScheduleTruck = async (regionId = "") => {
        try {

            const endpoint = regionId
                ? `open-schedule-truck?region_id=${regionId}`
                : "open-schedule-truck";

            const res = await withRFSToken.get(endpoint)
                .then(function (res) {
                    const scheduleTruckData = res.data.response_data.list;
                    setOpenScheduleTruck(scheduleTruckData);

                    const openScheduleTruckIndicatorsData = res.data.response_data.indicators;
                    setUrgentModerateSafe(openScheduleTruckIndicatorsData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const opntruck_rgn_drpdwn = async () => {
        try {
            const res = await withRFSToken.get('kpi-chart/get-region-list')
                .then(function (res) {
                    const RegionDropdwnData = res.data.response_data;
                    setTruckRgnDrpdwnLabel(RegionDropdwnData);
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleRegionChange = async (e) => {
        const selectedValue = e.target.value;
        setSelectedRegion(selectedValue);
        fetchOpenScheduleTruck(selectedValue === "All Region" ? "" : selectedValue);
    };

    useEffect(() => {
        if (isMounted.current) return;
        openTruckOrder();
        fetchOpenScheduleTruck();
        opntruck_rgn_drpdwn();
        isMounted.current = true;
    }, []);

    const [loaderModal, setLoaderModal] = useState(false);

    const clearSearch = () => {
        setSearchData({ search_area: '', o_id: '' })
    }
    const handleSearchChange = (event) => {
        const { name, value } = event.target;
        setSearchData(prevData => ({
            ...prevData,
            [name]: value,
            ...(name === 'search_area' && { o_id: '', tr_date: '' }), // Reset `o_id` if `search_area` changes
        }));
        if (name === 'tr_date' && value) {
            fetchSearchList(value)
        } if (name === 'search_area' && value === 'awb_manager') {
            fetchSearchList('', 'awb_manager');
        }
    }
    const fetchSearchData = async () => {
        try {

            const res = await withRFSToken.post(TRUCKERSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSearchItems(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSearchList = async (dta, tn) => {
        const payload = { tab_name: tn ?? searchData.search_area, date: dta }
        try {
            const res = await withRFSToken.post('rfs-filter', payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (tn) {
                        setSearchItems({ ...searchItems, awbList: innerData ?? [] });
                    } else {
                        setSearchItems({ ...searchItems, truckList: innerData ?? [] });
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleSearch = async () => {
        if (searchData.search_area === 'booking_truck') {
            localStorage.removeItem('BTDetails');
            const dataToSend = { bookingtruck_date_id: searchData?.o_id, date: searchData?.tr_date, bookingtruck_id: searchData.bookingtruck_id }
            localStorage.setItem('BTDetails', JSON.stringify(dataToSend));
            window.location.href = '/BookingtruckDetails'
        } else if (searchData.search_area === 'truck_order') {
            localStorage.removeItem('TODetails');
            const storageData = { truck_orders_id: searchData.o_id, tab: 'shipment' };
            localStorage.setItem('TODetails', JSON.stringify(storageData));
            window.location.href = '/TruckOrderDetails'
        } else {

            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD: { awb_no: searchData.o_label.trim(' '), awb_id: searchData.o_id },
                Left: {},
                sec: 'D',
                Back: { url: '/Dashboard', tab: '' }
            };
            localStorage.setItem('OVDetails', JSON.stringify(storageData));
            // localStorage.setItem('tab', 'assets');
            // window.location.href = '/TruckMonitor/OrdersViewDetails'
            window.location.href = '/TruckMonitor/Details'

        }
    }

    const detailsPageRedirect = async (number, dateid) => {
        try {
            const res = await withRFSToken.post(BOOKINGTRUCKDETAILS, { bookingtruck_id: number, bookingtruck_date_id: dateid, })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code == 200) {
                        localStorage.removeItem('BTDetails');
                        localStorage.setItem('BTDetails', JSON.stringify(res.data.response_data));
                        window.location.href = '/BookingtruckDetails'
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }

    }

    const opnTruckOrderRedirect = (dta) => {
        localStorage.removeItem('TODetails');
        const alldata = dta;
        const storageData = { ...alldata, tab: 'manage' };
        localStorage.setItem('TODetails', JSON.stringify(storageData));
        window.location.href = '/TruckOrderDetails'
    }

    // const truckRequestCount = truckOrder.filter(item => item.status === "Requested").length;
    // setrequestCount(truckRequestCount);

    const operational_truck_no = (truckOrder.operational_truck_no)

    return (
        <div className="">
            <Header logo_url='/BookingtruckSchedule' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab position-relative">
                        <TopMenu module='RFS' />
                        <div className='view_filter' style={{ position: 'absolute', top: '12px', right: '0' }}>
                            <Dropdown onToggle={(isOpen) => { if (!isOpen) { clearSearch(); } }}>
                                <Dropdown.Toggle variant="link" id="dropdown-basic" >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} /> Search
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='filter_menu charter_from'>
                                    <div className='d-flex justify-content-between filter_text'><h3>Search </h3>  <Link to='#' onClick={clearSearch}>Clear</Link></div>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-1">
                                                <Form.Label>Search Area</Form.Label>
                                                <Form.Select aria-label="Default select example" value={searchData.search_area} name='search_area' onChange={handleSearchChange}>
                                                    <option value=''>Select</option>
                                                    <option value="awb_manager">AWB No.</option>
                                                    <option value="booking_truck">Scheduled Truck</option>
                                                    {/* <option value="truck_order">Operational Truck</option> */}
                                                </Form.Select>

                                            </Form.Group>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>
                                    {searchData.search_area &&
                                        <Row>
                                            {searchData.search_area == 'awb_manager' ?
                                                <Col>
                                                    <Form.Group className="mb-1">
                                                        <Form.Label>Select AWB Number</Form.Label>
                                                        {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                        <Select
                                                            options={searchItems.awbList || []}
                                                            placeholder="Select number"
                                                            className='down_selct'
                                                            onChange={(selected) => {
                                                                setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label });
                                                            }}
                                                            // isMulti
                                                            // name="status"
                                                            value={searchItems.awbList?.find(value => value.label === searchData.o_label) || ''}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                :
                                                <>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label>Truck Date</Form.Label>
                                                            <Form.Control type="date" name='tr_date' onChange={handleSearchChange} value={searchData.tr_date} />
                                                        </Form.Group>
                                                    </Col>
                                                    {searchData.tr_date &&
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>{searchData.search_area == 'booking_truck' ? 'Scheduled' : 'Operational'} Truck No.</Form.Label>
                                                                {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                                <Select
                                                                    options={searchItems.truckList || []}
                                                                    placeholder="Select number"
                                                                    className='down_selct'
                                                                    onChange={(selected) => {
                                                                        if (searchData.search_area == 'booking_truck') {
                                                                            setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, bookingtruck_id: selected.bookingtruck_id });
                                                                        } else {
                                                                            setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, });
                                                                        }
                                                                    }}
                                                                    // isMulti
                                                                    // name="status"
                                                                    value={searchItems.truckList?.find(value => value.label === searchData.o_label) || ''}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    }

                                                </>
                                            }
                                        </Row>
                                    }
                                    <div className="mt-3 text-end"><Button variant="primary" className='adduld m-0' onClick={handleSearch}>Search</Button></div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="">
                            <div className="allcontent-fl">
                                <div className='opnpln-wrap'>
                                    <div className='opnpln-box opnpln-left'>
                                        <div className='opnplnhead-wrap d-flex justify-content-between'>
                                            <div className='opnpln-head'>
                                                <h2>Open Planning</h2>
                                                <p>Booking trucks to be schedule next 24 hours.</p>
                                            </div>
                                            {/* <div className='rgn-div'>
                                                <Form.Select aria-label="Default select example" onChange={opntruck_rgn_drpdwn}>
                                                    <option>All Region</option>
                                                    {truckRgnDrpdwnLabel && truckRgnDrpdwnLabel.length > 0 ? (
                                                        truckRgnDrpdwnLabel?.map((item, index) => (
                                                            <option key={index} value={item.value}>{item.label}</option>
                                                        ))
                                                    ) : (
                                                        <option disabled>Loading...</option>
                                                    )}
                                                </Form.Select>
                                            </div> */}
                                            <div className='rgn-div'>
                                                <Form.Select
                                                    aria-label="Select Region"
                                                    value={selectedRegion}
                                                    onChange={handleRegionChange}
                                                >
                                                    <option value="All Region">All Region</option>

                                                    {truckRgnDrpdwnLabel && truckRgnDrpdwnLabel.length > 0 ? (
                                                        truckRgnDrpdwnLabel.map((item, index) => (
                                                            <option key={index} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option disabled>Loading...</option>
                                                    )}
                                                </Form.Select>
                                            </div>
                                        </div>
                                        <div className='dash-box-mn d-flex justify-content-between gy-2'>
                                            <div className='dash-box-div dsh-rd'>
                                                <div className='dash-box-ot d-flex justify-content-between align-items-center'>
                                                    <div className='dash-box'>
                                                        <h3>Urgent ({urgentModerateSafeCount.urgent_hour}) </h3>
                                                        <h2>{urgentModerateSafeCount.urgent}</h2>
                                                    </div>
                                                    <div className='dash-ico'>
                                                        <img src={info} alt="My Image" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='dash-box-div dsh-yl'>
                                                <div className='dash-box-ot d-flex justify-content-between align-items-center'>
                                                    <div className='dash-box'>
                                                        <h3>Moderate ({urgentModerateSafeCount.moderate_hour}) </h3>
                                                        <h2>{urgentModerateSafeCount.moderate}</h2>
                                                    </div>
                                                    <div className='dash-ico'>
                                                        <img src={alert1} alt="My Image" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='dash-box-div dsh-gr'>
                                                <div className='dash-box-ot d-flex justify-content-between align-items-center'>
                                                    <div className='dash-box'>
                                                        <h3>Safe ({urgentModerateSafeCount.safe_hour}) </h3>
                                                        <h2>{urgentModerateSafeCount.safe}</h2>
                                                    </div>
                                                    <div className='dash-ico'>
                                                        <img src={ck1} alt="My Image" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='dash-tbl'>
                                            <Loader isLoading={loaderModal} />
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Truck Number</th>
                                                        <th>Route</th>
                                                        <th>Departure In</th>
                                                        <th>Planning</th>
                                                        <th>Truck</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {openScheduleTruck.length > 0 ? (
                                                        openScheduleTruck.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.truck_no}</td>
                                                                <td>{item.route}</td>
                                                                <td>
                                                                    <span className={item.departure_color == "green"
                                                                        ? "dp-tm dp-tm-grn "
                                                                        : item.departure_color == "orange"
                                                                            ? "dp-tm dp-tm-or"
                                                                            : item.departure_color == "red"
                                                                                ? "dp-tm dp-tm-rd"
                                                                                : ""}>
                                                                        {item.departure_in}
                                                                    </span>
                                                                </td>
                                                                <td><span className=''><img src={item.planning.icon === "red-cross"
                                                                    ? close
                                                                    : item.planning.icon === "green-check"
                                                                        ? ck2
                                                                        : ""
                                                                }
                                                                    alt={item.planning.icon} /></span></td>
                                                                {/* <td><span className=''><img src={ck2} alt="" /></span></td> */}
                                                                <td><span className=''><img src={item.truck.icon == "red-cross"
                                                                    ? close
                                                                    : item.truck.icon == "green-check"
                                                                        ? ck2
                                                                        : ""
                                                                } alt={item.truck.icon} /></span></td>
                                                                {/* <td><span className=''><img src={close} alt="" /></span></td> */}
                                                                <td><span className='ey'><img src={view1} alt="" className="nested_row_info" onClick={() => detailsPageRedirect(item.bookingtruck_id, item.bookingtruck_date_id)} /></span></td>
                                                            </tr>
                                                        ))
                                                    )
                                                        : (
                                                            <tr>
                                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                                </td>
                                                            </tr>
                                                        )}

                                                </tbody>
                                            </Table>
                                        </div>
                                        {/* <div className='btrk-box'>
                                            <div className='btrk-box-wrap'>
                                                <div className='btrk-head'>
                                                    <h3>Booking Truck Number</h3>
                                                    <h4>1HG CM123</h4>
                                                </div>
                                                <div className='btrk-head'>
                                                    <h3>Status</h3>
                                                    <h4><span className='crcl grn-cl'></span>Fully Planned</h4>
                                                </div>
                                                <div className='btrk-head'>
                                                    <span className="trk-view">
                                                        <img src={view1} alt="" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className='opnpln-box opnpln-right'>
                                        <div className='opnplnhead-wrap d-flex justify-content-between'>
                                            <div className='opnpln-head'>
                                                <h2>Open Truck Orders</h2>
                                                <p>Booking trucks to be schedule next 24 hours.</p>
                                            </div>
                                            {/* <div className='rgn-div'>
                                                <Form.Select aria-label="Default select example">
                                                    <option>All Region</option>
                                                    <option value="1">Region One</option>
                                                    <option value="2">Region Two</option>
                                                    <option value="3">Region Three</option>
                                                </Form.Select>
                                            </div> */}
                                        </div>
                                        <div className='dash-box-mn d-flex justify-content-between gy-2'>
                                            <div className='dash-box-div dsh-bl'>
                                                <div className='dash-box-ot d-flex justify-content-between align-items-center'>
                                                    <div className='dash-box'>
                                                        <h3>{truckRequestCount.label}</h3>
                                                        <h2>{truckRequestCount.count}</h2>
                                                    </div>
                                                    <div className='dash-ico'>
                                                        <img src={cb3} alt="My Image" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='dash-box-div dsh-yl'>
                                                <div className='dash-box-ot d-flex justify-content-between align-items-center'>
                                                    <div className='dash-box'>
                                                        <h3>{truckOfferReceived.label}</h3>
                                                        <h2>{truckOfferReceived.count}</h2>
                                                    </div>
                                                    <div className='dash-ico'>
                                                        <img src={ck3} alt="My Image" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='dash-tbl'>
                                            <Loader isLoading={loaderModal} />
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Truck Number</th>
                                                        <th>Route</th>
                                                        <th>Departure In</th>
                                                        <th>Status</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {truckOrder.length > 0 ? (
                                                        truckOrder.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.operational_truck_no}</td>
                                                                <td>{item.route}</td>
                                                                <td>
                                                                    <span className='dp-tm dp-tm-rd'>{item.departure_in}</span>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        className={
                                                                            item.status === "Booked"
                                                                                ? "bked bked-grn"
                                                                                : item.status === "Requested"
                                                                                    ? "bked bked-gry"
                                                                                    : item.status === "Offer Received"
                                                                                        ? "bked bked-org"
                                                                                        : ""
                                                                        }
                                                                    >
                                                                        {item.status}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span className='ey'>
                                                                        <a href="#">
                                                                            <img src={view1} alt="View" onClick={() =>opnTruckOrderRedirect(item)} />
                                                                        </a>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" style={{ textAlign: "center" }}>

                                                            </td>
                                                        </tr>
                                                    )}


                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard